import { Button } from "components/ButtonNew";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { EnergyAnalysisEnergyInputModal } from "./EnergyAnalysisEnergyInputModal";

type EnergyAnalysisUploadButtonProps = {
  className?: string;
  disabled?: boolean;
  onUpload: (file: File) => void;
  projectId: string;
};

export const EnergyAnalysisUploadButton = ({
  className,
  disabled,
  onUpload,
  projectId,
}: EnergyAnalysisUploadButtonProps) => {
  const { t } = useTranslation();
  const [uploadOpen, setUploadOpen] = useState(false);
  return (
    <div className={className}>
      <Button
        disabled={disabled}
        isActive={uploadOpen}
        onClick={() => setUploadOpen(true)}
        size="sm"
        startIconName="Upload"
        variant="tertiary"
      >
        {t("BuildingProfile.energyAnalysis.upload")}
      </Button>
      <EnergyAnalysisEnergyInputModal
        disabled={disabled}
        modalOpen={uploadOpen}
        onUpload={onUpload}
        projectId={projectId}
        setModalOpen={setUploadOpen}
      />
    </div>
  );
};
